<script setup>
import {ref, onMounted, computed} from 'vue'
import {useStore} from "vuex";
import axios from "axios";
import {useScrollBottom} from "@/use/scroll-bottom";

const store = useStore()

// календарь
const days = ref([])
const closedDays = ref([])
const currDay = ref(0)
const selectedDate = ref('')

const day = ref(0)
const month = ref(new Date().getMonth())
const year = ref(new Date().getFullYear())

//----------------------------------------------------------------------
// eslint-disable-next-line no-undef
const props = defineProps({
  minDelay:{
    type: String,
    required: true,
  },
})

onMounted( ()=>{
  init()
})

const init = async () => {
  const url = process.env.VUE_APP_API + "closed-days.php";
  await axios
      .get(url)
      .then(response => (closedDays.value = response.data))
      .catch(error => alert(error));
  days.value = calendar(year.value, month.value)
}

// new Date(2023, 0, 1) месяц начинается с 0
const calendar = (year, month) => {

  // console.log(day)
  // количество дней в месяце [month]
  const daysInMonth = new Date(year,  month+1, 0).getDate()

  // какой день недели 1-е число месяца
  const numFirstDayWeek = new Date(year, month, 1).getDay();
  let counter = 0
  if (numFirstDayWeek == 0) {
    counter = -6
  } else {
    counter = -(numFirstDayWeek) + 1;
  }

  // сколько строк в календаре
  let rows = 5
  if (counter <= -5) {
    rows = 6
  }
  let days = [];
  let index=0
  for (let i = 1; i <= rows; i++){
    for (let j = 1; j <= 7; j++) {
      counter++
      index++
      let obj = {}
      if (counter > 0 && counter <= daysInMonth){
        obj = {id: index, row: i, num: j, counter: counter}
      } else {
        obj = {id: index, row: i, num: j, counter: 0}
      }
      days.push(obj)
    }
  }
  //console.log(days)
  return days
}

//----------------------------------------------------------------------
const isSelected = (day) => {
  const d = dayToStr(day)+'.'+monthToStr(month.value)+'.'+year.value
  if (d === selectedDate.value){
    return true
  }
  return false
}

// закрытые даты
const isClosed = (day, num) => {

  let isDateClosed = false
  const t = new Date().getDate()      // сегодняшняя дата
  const m = new Date().getMonth()     // текущий месяц (номер-1)
  //month.value выбранные в календаре месяц
  const y = new Date().getFullYear()  // текущий год
  //year.value выбранные в календаре год

  const minDelay = Number(props.minDelay)
  // количество дней в месяце [month]
  const daysInMonth = new Date(y,  m+1, 0).getDate()
  // количество дней в следующем месяце, которые надо пропустить (>0)
  const countDaysNextMonth = minDelay - (daysInMonth - t)

  //что будет в декабре ?

  if (
     (year.value < y)
      || (month.value < m && year.value == y)
      || (day <= (t + minDelay) && month.value == m && year.value == y)
      || (countDaysNextMonth > 0 && (day < countDaysNextMonth && month.value == m + 1 && year.value == y))
      || (num == 6 || num == 7)
  ){

    isDateClosed = true

  } else {

    closedDays.value.forEach(function(date) {
      let arr = date.split('.');
      if (day == arr[0] && (month.value + 1) == arr[1] && year.value == arr[2]){
        isDateClosed = true
      }
    });

  }
  return isDateClosed
}


//----------------------------------------------------------------------

// выбрать дату
const setDate = (day, num, isClosed) => {
  if (!isClosed){
    selectedDate.value = dayToStr(day) +'.'+ monthToStr(month.value) +'.'+ year.value
    currDay.value = day
    store.commit('dateModule/setDateAction', selectedDate.value)
    // useScrollBottom(элемент) кроме скролла вниз устанавливает фокус в указанный элемент
    setTimeout(() => useScrollBottom('summa-payment'), 300);
  }
}

//----------------------------------------------------------------------

// месяц в строку с учетом 0
const monthToStr = (m) => {
  const month = (m + 1 < 10) ? '0' + (m + 1) : m + 1
  return month;
}

//----------------------------------------------------------------------

// число в строку с учетом 0
const dayToStr = (d) => {
  const day = (d < 10) ? '0' + d : d
  return day;
}

//----------------------------------------------------------------------

const getMonth = computed( () => {
  let monthName = ''
  switch (month.value){
    case 0: monthName = 'Январь'
      break
    case 1: monthName = 'Февраль'
      break
    case 2: monthName = 'Март'
      break
    case 3: monthName = 'Апрель'
      break
    case 4: monthName = 'Май'
      break
    case 5: monthName = 'Июнь'
      break
    case 6: monthName = 'Июль'
      break
    case 7: monthName = 'Август'
      break
    case 8: monthName = 'Сентябрь'
      break
    case 9: monthName = 'Октябрь'
      break
    case 10: monthName = 'Ноябрь'
      break
    case 11: monthName = 'Декабрь'
      break
  }
  return monthName + ', ' + year.value;
})

//----------------------------------------------------------------------

const next = () => {
  month.value++
  if (month.value > 11){
    month.value = 0
    year.value++
  }
  days.value = calendar(year.value, month.value, day.value)
}

//----------------------------------------------------------------------

const prev = () => {
  month.value--
  if (month.value < 0){
    month.value = 11
    year.value--
  }
  days.value = calendar(year.value, month.value, day.value)
}

</script>

<template>
    <div class="row">
      <div class="col-12">
        <v-card addClass="card-info card-outline m-0">
          <div class="calendar-container">
            <h2 class="pb-2 text-center">{{ getMonth }}</h2>
            <div class="d-flex justify-content-between pb-3">

              <v-icon
                  class="action-icon--calendar"
                  icon="mdi:comment-arrow-left-outline"
                  @click.prevent="prev()"
              ></v-icon>

              <v-icon
                  class="action-icon--calendar"
                  icon="mdi:comment-arrow-right-outline"
                  @click.prevent="next()"
              ></v-icon>

            </div>

            <div class="calendar-cell calendar-title">Пн</div>
            <div class="calendar-cell calendar-title">Вт</div>
            <div class="calendar-cell calendar-title">Ср</div>
            <div class="calendar-cell calendar-title">Чт</div>
            <div class="calendar-cell calendar-title">Пт</div>
            <div class="calendar-cell calendar-title" style="color:#dc3545">Сб</div>
            <div class="calendar-cell calendar-title" style="color:#dc3545">Вс</div>
            <div class="clearfix"></div>
            <div
                v-for="day in days" :key="day.id"
            >
              <div
                v-if="day.counter"
                :class="[
                'calendar-cell',
                isClosed(day.counter, day.num) ? 'closed-day' : 'open-day',
                isSelected(day.counter) ? 'selected-day' : ''
                ]"
                @click="setDate(day.counter, day.num, isClosed(day.counter, day.num))">
                {{ day.counter }}
              </div>
              <div v-else class="calendar-cell calendar-date--empty">&nbsp;</div>
              <div v-if="day.num === 7" class="clearfix"></div>
            </div>
          </div>
        </v-card>
      </div>
    </div>

</template>
<style scoped>
.calendar-container{
  width: 745px;
}
.calendar-cell{
  float:left;
  width:104px;
  padding:20px 0;
  text-align: center;
  border: 1px solid #dee2e6;
  margin:1px;
}
.open-day{
  cursor: pointer;
}
.open-day:hover{
  border-bottom: 1px solid #dc3545;
}
.calendar-title{
  font-weight: bold;
}
.calendar-date--empty{
  background-color: #f4f6f9;
}
.weekend{color: #dc3545;}
.selected-day{background-color: #fcffa1;}
.closed-day{background-color: #f4f6f9;}

@media only screen and (max-width : 800px) {
  .calendar-container{
    width: 100%;
  }
  .calendar-cell{
    float:left;
    width: calc(14.28% - 2px);
    padding:15px 0;
  }
}

</style>